export function tabs() {
    $(".tab-nav a").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var tabId = $this.attr("href");
        $this.parents("li").addClass("active").siblings("li").removeClass("active");

        $(tabId).addClass("active").siblings("div").removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js